export const ATTENDANCE_PAGE_PERMISSIONS = Object.freeze({
  faceMachines: 'attendance.face_machines',
  punchReview: 'attendance.manage',
});
export const EMPLOYEE_SALARY_VIEW_PERMISSION = 'employees.view_salary';

const ADMIN_ROUTE_ACCESS = [
  {path:'/admindashboard/accounting',permissions:['accounting.view']},
  ...['setup','ledgers','vouchers','trial','ledger-statement','party-accounts','posting-setup','purchase-invoices','supplier-returns'].map(section=>({path:`/admindashboard/accounting/${section}`,permissions:['accounting.view']})),
  {path: "/admindashboard/sales/support-tickets", permissions: ["customer_support.view"]},
  { path: '/admindashboard/inventory/online-pricing', permissions: ['inventory.adjust'] },
  // Authenticated dashboard
  { path: "/admindashboard", permissions: [] },

  // Masters
  {
    path: "/admindashboard/masters",
    permissions: [
      "brands.view",
      "categories.view",
      "subcategories.view",
      "colors.view",
      "sizes.view",
      "units.view",
      "seasons.view",
      "products.view",
      "suppliers.view",
      "stores.view",
    ],
  },
  {
    path: "/admindashboard/masters/branches",
    permissions: ["branches.view"],
  },
  {
    path: "/admindashboard/masters/tax-catalog",
    permissions: ["tax_catalog.view"],
  },
  {
    path: "/admindashboard/masters/brands",
    permissions: ["brands.view"],
  },
  {
    path: "/admindashboard/masters/categories",
    permissions: ["categories.view"],
  },
  {
    path: "/admindashboard/masters/sub-categories",
    permissions: ["subcategories.view"],
  },
  {
    path: "/admindashboard/masters/colors",
    permissions: ["colors.view"],
  },
  {
    path: "/admindashboard/masters/sizes",
    permissions: ["sizes.view"],
  },
  {
    path: "/admindashboard/masters/sizes/groups",
    permissions: ["sizesgroups.view"],
  },
  {
    path: "/admindashboard/masters/units",
    permissions: ["units.view"],
  },
  {
    path: "/admindashboard/masters/seasons",
    permissions: ["seasons.view"],
  },
  {
    path: "/admindashboard/masters/stores",
    permissions: ["stores.view"],
  },
  {
    path: "/admindashboard/masters/suppliers",
    permissions: ["suppliers.view"],
  },
  {path:'/admindashboard/masters/commercial-agreements', permissions:['suppliers.view']},
  {
    path: "/admindashboard/masters/products",
    permissions: ["products.view"],
  },
  {
    path: "/admindashboard/inventory/barcode-labels",
    permissions: ["barcode_labels.view"],
  },
  {
    path: "/admindashboard/masters/products/add",
    permissions: ["products.create"],
  },
  {
    path: "/admindashboard/masters/products/:id",
    permissions: ["products.view"],
  },
  {
    path: "/admindashboard/masters/products/:id/edit",
    permissions: ["products.update"],
  },
  {
    path: "/admindashboard/pos/counters",
    permissions: ["pos.manage_counters"],
  },
  {
    path: "/admindashboard/sales/pos-bills",
    permissions: ["pos.view_reports"],
  },
  {
    path: "/admindashboard/masters/roles",
    permissions: ["roles.view"],
  },
  {
    path: "/admindashboard/masters/users",
    permissions: ["users.view"],
  },

  // Inventory
  {
    path: "/admindashboard/inventory",
    permissions: ["inventory.view"],
  },
  {
    path: "/admindashboard/inventory/ledger",
    permissions: ["inventory.view"],
  },
  {
    path: "/admindashboard/inventory/adjustment",
    permissions: ["inventory.adjust"],
  },
  {
    path: "/admindashboard/inventory/transfers",
    permissions: ["inventory.view"],
  },
  {
    path: "/admindashboard/inventory/transfers/create",
    permissions: ["inventory.transfer"],
  },
  {
    path: "/admindashboard/inventory/count",
    permissions: ["inventory.count"],
  },
  {
    path: "/admindashboard/inventory/low-stock",
    permissions: ["inventory.view"],
  },
  {
    path: "/admindashboard/inventory/valuation",
    permissions: ["inventory.view"],
  },

  // Purchases
  {
    path: "/admindashboard/purchases",
    permissions: ["purchases.view"],
  },
  {
    path: "/admindashboard/purchases/orders",
    permissions: ["purchases.view"],
  },
  {
    path: "/admindashboard/purchases/create",
    permissions: ["purchases.create"],
  },
  {
    path: "/admindashboard/purchases/:id",
    permissions: ["purchases.view"],
  },
  {
    path: "/admindashboard/purchases/grn",
    permissions: ["purchases.receive"],
  },
  {
    path: "/admindashboard/purchases/grn/create",
    permissions: ["purchases.receive"],
  },
  {
    path: "/admindashboard/purchases/grn/:id",
    permissions: ["purchases.receive"],
  },
  {
    path: "/admindashboard/purchases/returns",
    permissions: ["purchases.view"],
  },
  {
    path: "/admindashboard/purchases/returns/create",
    permissions: ["purchases.create"],
  },
  {
    path: "/admindashboard/purchases/returns/:id",
    permissions: ["purchases.view"],
  },

  // Sales dashboard
  {
    path: "/admindashboard/sales",
    permissions: ["sales_dashboard.view"],
  },

  // Customers
  {
    path: "/admindashboard/sales/customers",
    permissions: ["customers.view"],
  },
  {
    path: "/admindashboard/sales/customers/:id",
    permissions: ["customers.view"],
  },

  // Ecommerce orders
  {
    path: "/admindashboard/sales/ecommerce-orders",
    permissions: ["ecommerce_orders.view"],
  },

  // Sales orders
  {
    path: "/admindashboard/sales/orders/create",
    permissions: ["sales_orders.create"],
  },
  {
    path: "/admindashboard/sales/orders/list",
    permissions: ["sales_orders.view"],
  },
  {
    path: "/admindashboard/sales/orders/:id",
    permissions: ["sales_orders.view"],
  },

  // Delivery challans
  {
    path: "/admindashboard/delivery/challan/create",
    permissions: ["delivery_challans.create"],
  },
  {
    path: "/admindashboard/delivery/challan/list",
    permissions: ["delivery_challans.view"],
  },
  {
    path: "/admindashboard/delivery/challan/:id",
    permissions: ["delivery_challans.view"],
  },

  // Sales invoices
  {
    path: "/admindashboard/sales/invoice/list",
    permissions: ["sales_invoices.view"],
  },
  {
    path: "/admindashboard/sales/invoice/:id",
    permissions: ["sales_invoices.view"],
  },

  // Sales payments
  {
    path: "/admindashboard/sales/payment",
    permissions: ["sales_payments.create"],
  },

  // Sales returns
  {
    path: "/admindashboard/sales/returns/create",
    permissions: ["sales_returns.create"],
  },
  {
    path: "/admindashboard/sales/returns",
    permissions: ["sales_returns.view"],
  },
  {
    path: "/admindashboard/sales/returns/:id",
    permissions: ["sales_returns.view"],
  },

  // Sales credit notes
  {
    path: "/admindashboard/sales/credit-notes",
    permissions: ["sales_credit_notes.view"],
  },
  {
    path: "/admindashboard/sales/credit-notes/:id",
    permissions: ["sales_credit_notes.view"],
  },

  // Marketing
  {
    path: "/admindashboard/marketing/promotions",
    permissions: ["promotions.view"],
  },

  // HRMS - employees
  { path: "/admindashboard/profile", permissions: [] },
  { path: "/admindashboard/employee-advances/new", permissions: ["employee_advances.manage"] },
  { path: "/admindashboard/employee-advances/:advanceId", permissions: ["employee_advances.view"] },
  {
    path: "/admindashboard/employees",
    permissions: ["employees.view"],
  },
  {
    path: "/admindashboard/employee-advances",
    permissions: ["employee_advances.view"],
  },
  {
    path: "/admindashboard/employees/add",
    permissions: ["employees.create"],
  },
  {
    path: "/admindashboard/employees/:id",
    permissions: ["employees.view"],
  },
  {
    path: "/admindashboard/employees/:id/edit",
    permissions: ["employees.update"],
  },

  // HRMS - attendance
  {
    path: "/admindashboard/attendance",
    permissions: ["attendance.view_team"],
  },
  {
    path: "/admindashboard/attendance/daily",
    permissions: ["attendance.view_team"],
  },
  {
    path: "/admindashboard/attendance/monthly",
    permissions: ["attendance.view_team"],
  },
  {
    path: "/admindashboard/attendance/corrections",
    permissions: ["attendance.manage"],
  },
  {
    path: "/admindashboard/attendance/face-machines",
    permissions: [ATTENDANCE_PAGE_PERMISSIONS.faceMachines],
  },
  {
    path: "/admindashboard/attendance/punch-review",
    permissions: [ATTENDANCE_PAGE_PERMISSIONS.punchReview],
  },

  // HRMS - leave
  {
    path: "/admindashboard/leave",
    permissions: ["leave.approve"],
  },
  {
    path: "/admindashboard/leave/apply",
    permissions: ["leave.record_direct"],
  },
  {
    path: "/admindashboard/leave/balance",
    permissions: ["leave.manage_balances"],
  },
  {
    path: "/admindashboard/leave/types",
    permissions: ["leave.manage_types"],
  },
  {
    path: "/admindashboard/leave/:id",
    permissions: ["leave.approve"],
  },
  {
    path: "/admindashboard/leave/requests/:id",
    permissions: ["leave.approve"],
  },
  {
    path: "/admindashboard/leave/holiday-policies",
    permissions: ["attendance_holiday_policies.view"],
  },
  {
    path: "/admindashboard/hrms-reports",
    permissions: ["hrms.reports.view"],
  },

  {path: "/admindashboard/hrms-reports/:reportKey", permissions: ["hrms.reports.view"]},

  // Payroll
  {
    path: "/admindashboard/payroll",
    permissions: ["payroll.view"],
  },
  {
    path: "/admindashboard/payroll/generate",
    permissions: ["payroll.generate"],
  },
  {
    path: "/admindashboard/payroll/off-cycle",
    permissions: ["payroll.generate"],
  },
  {
    path: "/admindashboard/payroll/payslips",
    permissions: ["payslips.view_team"],
  },
  {
    path: "/admindashboard/payroll/payslips/:id",
    permissions: ["payslips.view_team"],
  },

  // Company / HR settings
  {
    path: "/admindashboard/settings",
    permissions: ["settings.view", "auth_sessions.revoke_all"],
  },
  {
    path: "/admindashboard/settings/branches",
    permissions: ["branches.view"],
  },
  {
    path: "/admindashboard/settings/departments",
    permissions: ["departments.view"],
  },
  {
    path: "/admindashboard/settings/designation",
    permissions: ["designations.view"],
  },
  {
    path: "/admindashboard/settings/roles",
    permissions: ["roles.manage"],
  },

  // POS reports
  {
    path: "/admindashboard/reports/pos",
    permissions: ["pos.view_reports"],
  },

  // Tools
  { path: "/admindashboard/tools/importcenter", permissions: ["imports.view"] },
  { path: "/admindashboard/tools/importcenter/review/:jobId", permissions: ["imports.view"] },
  { path: "/admindashboard/tools/datatemplates", permissions: ["imports.view"] },
  // Legacy placeholder: restrict access until real export permissions exist.
  { path: "/admindashboard/tools/exportcenter", permissions: ["settings.view"] },
  {
    path: "/admindashboard/tools",
    permissions: ["imports.view","audit_logs.view","tools.backup_restore.view","tools.system_jobs.view"],
  },
  {
    path: "/admindashboard/tools/auditlogs",
    permissions: ["audit_logs.view"],
  },
  {
    path: "/admindashboard/tools/importhistory",
    permissions: ["imports.view"],
  },
  {
    path: "/admindashboard/tools/systemjobs",
    permissions: ["tools.system_jobs.view"],
  },
  {
    path: "/admindashboard/tools/backuprestore",
    permissions: ["tools.backup_restore.view"],
  },

  // Analytics
  { path: "/admindashboard/analytics/customsales", permissions: ["analytics.sales"] },
  {
    path: "/admindashboard/analytics",
    permissions: ["analytics.view"],
  },
  {
    path: "/admindashboard/analytics/sales",
    permissions: ["analytics.sales"],
  },
  {
    path: "/admindashboard/analytics/customers",
    permissions: ["analytics.customers"],
  },
  {
    path: "/admindashboard/analytics/inventory",
    permissions: ["analytics.inventory"],
  },
  {
    path: "/admindashboard/analytics/purchases",
    permissions: ["analytics.purchases"],
  },
  {
    path: "/admindashboard/analytics/pos",
    permissions: ["analytics.pos"],
  },
  {
    path: "/admindashboard/analytics/finance",
    permissions: ["analytics.finance"],
  },
  { path: '/admindashboard/analytics/gst', permissions: ['analytics.gst'] },
  {
    path: "/admindashboard/reports/gst",
    permissions: ["reports.gst.view"],
  },
  {
    path: "/admindashboard/reports/sales-detailed",
    permissions: ["reports.sales_detailed.view"],
  },
  {
    path: "/admindashboard/reports/sales-tax-register",
    permissions: ["reports.sales_tax_register.view"],
  },
  {
    path: "/admindashboard/reports/sales-register-summary",
    permissions: ["reports.sales_register_summary.view"],
  },
  {
    path: "/admindashboard/reports/cashier-wise",
    permissions: ["reports.cashier_wise.view"],
  },
  {
    path: "/admindashboard/reports/stock",
    permissions: ["reports.stock.view"],
  },
  { path: "/admindashboard/reports/stock-ageing", permissions: ["reports.stock_ageing.view"] },
  { path: "/admindashboard/reports/inventory-movement", permissions: ["reports.inventory_movement.view"] },
  { path: "/admindashboard/reports/purchase-returns", permissions: ["reports.purchase_returns.view"] },
  { path: "/admindashboard/reports/online-payments", permissions: ["reports.online_payments.view"] },
  { path: "/admindashboard/reports/customer-loyalty-ledger", permissions: ["reports.customer_loyalty_ledger.view"] },
  { path: "/admindashboard/reports/gift-card-register", permissions: ["reports.gift_card_register.view"] },
  { path: "/admindashboard/reports/stock-adjustment-variance", permissions: ["reports.stock_adjustment_variance.view"] },
  { path: "/admindashboard/reports/season-wise-stock", permissions: ["reports.season_wise_stock.view"] },
  { path: "/admindashboard/reports/size-sell-through", permissions: ["reports.size_sell_through.view"] },
  { path: "/admindashboard/reports/reorder-stock-cover", permissions: ["reports.reorder_stock_cover.view"] },
  { path: "/admindashboard/reports/dead-stock", permissions: ["reports.dead_stock.view"] },
  { path: "/admindashboard/reports/brand-trading", permissions: ["reports.brand_trading.view"] },
  { path: "/admindashboard/reports/counter-shift", permissions: ["reports.counter_shift.view"] },
  { path: "/admindashboard/reports/grn-reconciliation", permissions: ["reports.grn_reconciliation.view"] },
  { path: "/admindashboard/reports/price-grn-audit", permissions: ["reports.price_grn_audit.view"] },
  { path: "/admindashboard/reports/online-fulfilment", permissions: ["reports.online_fulfilment.view"] },
  { path: "/admindashboard/reports/attendance-exceptions", permissions: ["reports.attendance_exceptions.view"] },
  { path: "/admindashboard/reports/advance-outstanding", permissions: ["reports.advance_outstanding.view"] },
  { path: "/admindashboard/reports/transfer-reconciliation", permissions: ["reports.transfer_reconciliation.view"] },
  { path: "/admindashboard/reports/slow-moving", permissions: ["reports.slow_moving.view"] },
  { path: "/admindashboard/reports/coupon-performance", permissions: ["reports.coupon_performance.view"] },
  { path: "/admindashboard/reports/customer-retention", permissions: ["reports.customer_retention.view"] },
  { path: "/admindashboard/reports/catalogue-exceptions", permissions: ["reports.catalogue_exceptions.view"] },
  { path: "/admindashboard/reports/custom", permissions: ["custom_reports.view"] },
  { path: "/admindashboard/reports/channel-wise-sales", permissions: ["reports.channel_wise_sales.view"] },
  { path: "/admindashboard/reports/customer-purchase-history", permissions: ["reports.customer_purchase_history.view"] },
  { path: "/admindashboard/reports/product-profitability", permissions: ["reports.product_profitability.view"] },
  { path: "/admindashboard/reports/online-product-readiness", permissions: ["reports.online_product_readiness.view"] },
  { path: "/admindashboard/reports/sales-returns", permissions: ["reports.sales_returns.view"] },
  { path: "/admindashboard/reports/supplier-purchase-return", permissions: ["reports.supplier_purchase_return.view"] },
  { path: "/admindashboard/reports/discount-loyalty", permissions: ["reports.discount_loyalty.view"] },
  { path: "/admindashboard/reports/online-orders-detailed", permissions: ["reports.online_orders_detailed.view"] },
  {
    path: "/admindashboard/reports/product-wise-sale-stock",
    permissions: ["reports.product_wise_sale_stock.view"],
  },
  {
    path: "/admindashboard/reports/purchase-sale-wise",
    permissions: ["reports.purchase_sale_wise.view"],
  },
  {
    path: "/admindashboard/reports/gstr",
    permissions: ["reports.gstr.view"],
  },
  {
    path: "/admindashboard/reports/purchase",
    permissions: ["reports.purchase.view"],
  },
  {
    path: "/admindashboard/reports/agent-wise-sales",
    permissions: ["reports.agent_wise_sales.view"],
  },
  {
    path: "/admindashboard/analytics/employees",
    permissions: ["analytics.employees"],
  },
  {
    path: "/admindashboard/analytics/attendance",
    permissions: ["analytics.attendance"],
  },
  {
    path: "/admindashboard/analytics/payroll",
    permissions: ["analytics.payroll"],
  },
];

function matchesRoute(pathname, routePath) {
  const currentParts = pathname.split("/").filter(Boolean);
  const routeParts = routePath.split("/").filter(Boolean);

  if (currentParts.length !== routeParts.length) {
    return false;
  }

  return routeParts.every(
    (part, index) => part.startsWith(":") || part === currentParts[index],
  );
}

export function getUserRoleCodes(user) {
  return (user?.roles || [])
    .map((item) => {
      if (typeof item === "string") {
        return item;
      }

      return item?.role?.code || item?.code || "";
    })
    .filter(Boolean)
    .map((code) => code.trim().toUpperCase());
}

export function isSuperAdmin(user) {
  return getUserRoleCodes(user).includes("SUPER_ADMIN");
}

export function getUserPermissions(user) {
  const directPermissions = user?.permissions || [];

  const rolePermissions = (user?.roles || []).flatMap((item) => {
    const role = item?.role || item;
    return role?.permissions || [];
  });

  return [
    ...new Set(
      [...directPermissions, ...rolePermissions]
        .map((item) => {
          if (typeof item === "string") return item;
          return item?.permission?.code || item?.code;
        })
        .filter(Boolean)
        .map((permission) => permission.toLowerCase()),
    ),
  ];
}

export function hasPermission(user, permission) {
  if (!permission || isSuperAdmin(user)) {
    return true;
  }

  return getUserPermissions(user).includes(permission.toLowerCase());
}

export function hasAnyPermission(user, permissions = []) {
  if (isSuperAdmin(user) || permissions.length === 0) {
    return true;
  }

  return permissions.some((permission) => hasPermission(user, permission));
}

export function isProductionHiddenTool(pathname) {
  return process.env.NODE_ENV === "production" &&
    ["/admindashboard/tools/backuprestore", "/admindashboard/tools/systemjobs"]
      .some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

export function getFirstAccessibleAdminPath(user) {
  const firstAccessibleRoute = ADMIN_ROUTE_ACCESS.find(
    (route) =>
      route.path !== "/admindashboard" &&
      !route.path.includes(":") &&
      !isProductionHiddenTool(route.path) &&
      hasAnyPermission(user, route.permissions),
  );

  return firstAccessibleRoute?.path || "/unauthorized";
}

export function getAdminRoutePermissions(pathname) {
  const match = ADMIN_ROUTE_ACCESS.find((route) =>
    matchesRoute(pathname, route.path),
  );

  return match ? match.permissions : null;
}
